import { FieldInstruction } from 'containers/FormBuilder'
import InputField from 'form/fieldComponents/InputField'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

function coverageFieldValidation(): () => Yup.NumberSchema {
    return () => {
        return Yup.number()
            .required(FIELD_REQUIRED)
            .typeError('Coverage must be a dollar amount')
    }
}

export function createCoverageFieldWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Coverage',
            validator: coverageFieldValidation(),
        },
    }
}

function providerFieldValidation(): () => Yup.StringSchema {
    return () => {
        return Yup.string().required(FIELD_REQUIRED)
    }
}

export function createProviderFieldWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Provider Name',
            validator: providerFieldValidation(),
        },
    }
}

function termValidation(): () => Yup.NumberSchema {
    return () => {
        return Yup.number()
            .required(FIELD_REQUIRED)
            .typeError('Term must be a number')
    }
}

export function createTermFieldWithValidation(): FieldInstruction<
    typeof InputField
> {
    return {
        Component: InputField,
        config: {
            label: 'Term',
            validator: termValidation(),
        },
    }
}
